export default __webpack_public_path__ + "static/media/logo-white.750887a0.png";